<template lang="html">
  <div
    :id="id"
    class="highcharts"
    @click="$emit('click')"
  ></div>
</template>

<style scoped>
div.highcharts {
  width: 100%;
  height: 100%;
}
</style>

<script>
import Highcharts from 'highcharts'
import HighchartsMore from 'highcharts/highcharts-more'
import HighchartsSolidgauge from 'highcharts/modules/solid-gauge'
import debounce from 'lodash/debounce'
HighchartsMore(Highcharts)
HighchartsSolidgauge(Highcharts)

export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      default: null
    }
  },
  mounted () {
    if (!this.chart && this.options) {
      this.initChart()
    }
    // Make this available so it can be screenshot
    window.chartlist = window.chartlist || []
    window.chartlist.push(this)
  },
  created () {
    this.redrawFn = debounce(this.redraw, 200)
    window.addEventListener('resize', this.redrawFn)
  },
  computed: {
    chartOptions () {
      return {
        ...this.options,
        yAxis: {
          ...(this.options.yAxis || {}),
          allowDecimals: false
        }
      }
    }
  },
  methods: {
    redraw () {
      if (this.chart && typeof this.chart.reflow === 'function') {
        this.chart.reflow()
      }
    },
    addSeries (options) {
      this.delegateMethod('addSeries', options)
    },
    mergeOption (options) {
      this.delegateMethod('update', options)
    },
    showLoading (txt) {
      this.chart.showLoading(txt)
    },
    hideLoading () {
      this.chart.hideLoading()
    },
    delegateMethod (name, ...args) {
      if (!this.chart) {
        console.log(`Cannot call [$name] before the chart is initialized. Set prop [options] first.`, this)
        return
      }
      return this.chart[name](...args)
    },
    initChart () {
      if (!this.chart && this.options) {
        let _Highcharts = this.Highcharts || Highcharts
        this.chart = window.chart = new _Highcharts.Chart(this.$el, this.chartOptions)
      }
    },
    getSVG () {
      if (!this.chart) {
        return null
      }
      return this.chart.getSVG()
    },
    getBase64 () {
      if (!this.chart) {
        return null
      }
      let svgString = this.getSVG()

      // Use DOMParser to parse new svg element from svgString
      let parser = new DOMParser()
      let svgElem = parser.parseFromString(svgString, 'image/svg+xml').documentElement
      console.log('svg', svgElem)
      // Use toDataURL extension to generate Base64 string
      return svgElem.toDataURL()
    }
  },
  watch: {
    options (options) {
      if (!this.chart && options) {
        this.initChart()
      } else {
        this.chart.update(options)
        if (options.series && options.series.length) {
          while (this.chart.series.length > 0) {
            this.chart.series[0].remove(true)
          }
          options.series.forEach((series, index) => {
            this.chart.addSeries(series, index === options.series.length - 1)
          })
        }
      }
    }
  },
  beforeDestroy () {
    if (window.chartlist) {
      window.chartlist = window.chartlist.filter(c => c !== this)
    }
    if (this.chart) {
      this.chart.destroy()
    }
    window.removeEventListener('resize', this.redrawFn)
  }
}
</script>
